function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "b573f80a-d35c-4010-b1f5-06050ff06103",
  x: 59.1,
  y: 60.55,
  width: 33.73,
  height: 29.27,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "f8ebd4c8-6c4f-4b95-885e-d5ceddca2555",
  d: "M92.26 81.2a17.87 17.87 0 01-30.58-18.49c5.11-8.45 35.69 10.04 30.58 18.49z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "e72c0290-4bf6-4327-a0d2-3e146f370ebd",
  x: 102.27,
  y: 60.55,
  width: 33.73,
  height: 29.27,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "f8ebd4c8-6c4f-4b95-885e-d5ceddca2555",
  d: "M102.84 81.2a17.87 17.87 0 0030.58-18.49c-5.11-8.45-35.69 10.04-30.58 18.49z"
})), /*#__PURE__*/React.createElement("style", null, ".f8ebd4c8-6c4f-4b95-885e-d5ceddca2555{fill:#fff}.f4bd7fab-6cda-497f-a671-027ffc0222ef{fill:#bfbfbf;opacity:.7}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M161.21 93.92c-.26-.26-.52-.49-.77-.74a29.52 29.52 0 00-25.75-41.28 20.67 20.67 0 00-30.93-25.44A40.34 40.34 0 0026.5 49a20.66 20.66 0 10-4.33 40.43 52.94 52.94 0 0042.88 56.71 27.34 27.34 0 0050.43 12.76 40.34 40.34 0 0045.73-65z",
  fill: "#d3d3d3"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  className: "f4bd7fab-6cda-497f-a671-027ffc0222ef",
  cx: 59.61,
  cy: 129.23,
  rx: 28.6,
  ry: 29.06
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  className: "f4bd7fab-6cda-497f-a671-027ffc0222ef",
  cx: 125.74,
  cy: 89.14,
  rx: 57.32,
  ry: 58.23
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  className: "f4bd7fab-6cda-497f-a671-027ffc0222ef",
  cx: 80.29,
  cy: 49.46,
  rx: 42.86,
  ry: 43.54
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "f8ebd4c8-6c4f-4b95-885e-d5ceddca2555",
  d: "M92.26 81.2a17.87 17.87 0 01-30.58-18.49c5.11-8.45 35.69 10.04 30.58 18.49z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#b573f80a-d35c-4010-b1f5-06050ff06103)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 83.03,
  cy: 78.64,
  r: 5.86
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "f8ebd4c8-6c4f-4b95-885e-d5ceddca2555",
  d: "M102.84 81.2a17.87 17.87 0 0030.58-18.49c-5.11-8.45-35.69 10.04-30.58 18.49z"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#e72c0290-4bf6-4327-a0d2-3e146f370ebd)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 112.07,
  cy: 78.64,
  r: 5.86
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "f8ebd4c8-6c4f-4b95-885e-d5ceddca2555",
  d: "M134.82 115.11c-2.66 2-10.41 4.22-13.29 2s-2.26-10.23-.89-13.28M116.66 102c-1.49 3-7.25 8.5-10.66 7.8s-6.23-8.22-6.29-11.56M95.39 98.21c-.06 3.34-2.89 10.76-6.28 11.56S79.93 105 78.45 102M74.47 103.84c1.36 3 1.93 11-.9 13.28s-10.63 0-13.29-2"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M136.31 115.65a50.24 50.24 0 00-77.52 0",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: "3.8px"
});

function SvgFumes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fa58f081-81eb-461e-ac8e-7a8d1b3ee414",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.06 171.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFumes);
export default __webpack_public_path__ + "static/media/fumes.3fb355c1.svg";
export { ForwardRef as ReactComponent };